import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';
import Search from '../../../../components/Search/Search';
import {
  fetchTypeaheadResults as fetchTypeaheadResultsAction,
  clearGlobalSearch as clearGlobalSearchAction
} from '../../../../store/actions/typeahead';
import { selectTypeaheadResults, selectTypeaheadValue } from 'src/store/selectors/typeahead';
import TypeaheadResult from './TypeaheadResult';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import './Typeahead.scss';

const Typeahead: React.FC = () => {
  const dispatch = useDispatch();

  const user = useSelector(selectAuthenticatedUser);
  const results = useSelector(selectTypeaheadResults);
  const value = useSelector(selectTypeaheadValue);

  const onFetchTypeaheadResults = (userId: any, roleName: any, searchValue: string) => {
    dispatch(fetchTypeaheadResultsAction(userId, roleName, searchValue));
  };

  const clearGlobalSearch = () => dispatch(clearGlobalSearchAction());
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        clearGlobalSearch();
      }}
    >
      <div className="typeahead">
        <Search
          theme="dark"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onFetchTypeaheadResults(
              user.id,
              user.roles[0].role.name,
              e.target.value
            )
          }
          value={value}
          size={undefined}
        />
        {value && results.length > 0 && (
          <div className="typeahead__results">
            {results.map((result: any, index: number) => (
              <TypeaheadResult
                key={index}
                result={result}
                onClick={undefined}
              />
            ))}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
}

export default Typeahead;